<template>
  <div class="lds-roller" role="status" aria-label="جاري التحميل">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "LoadingRoller",
};
</script>
